<template>
  <v-autocomplete
    v-model="selected"
    :items="selectorOptions"
    :loading="loading"
    :label="single ? 'Проект' : 'Проекты'"
    item-value="id"
    item-text="name"
    :search-input.sync="search"
    no-data-text="Ничего не найдено"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    no-filter
    multiple
    :rules="rule"
    :disabled="disabled"
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length <= 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small v-for="projId in selected" :key="`project_selector${projId}`" >
          <span class="sliced-name">{{ getProjectName(projId) }}</span>
        </v-chip>
      </span>

      <span v-else class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ getProjectName(selected[0]) }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{selected.length - 1}})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{toggleAllText}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProjectSelector',
  props: {
    value: {
      required: true,
    },
    single: Boolean,
    selectedAll: Boolean,
    noRules: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      allSelectorOptions: [],
      selectorOptions: [],
      loading: true,
      search: null,
      rule: [
        v => {
          if (this.noRules || this.disabled) return true
          else {
            return !!v.length || 'Данное поле обязательно'
          }
        }
      ],
      debounceRequest: null,
    }
  },

  computed: {
    ...mapGetters({
      allProjects: 'graphql/allProjects',
    }),

    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit("input", selected)
      },
    },

    allItems() {
      return this.selected.length === this.selectorOptions.length
    },

    moreItems() {
      return this.selected.length > 0 && !this.allItems
    },

    icon() {
      if (this.allItems) return "mdi-close-box"
      if (this.moreItems) return "mdi-plus-box"
      return "mdi-checkbox-blank-outline"
    },

    toggleAllText() {
      if (this.allItems) return "Отменить все"
      if (this.moreItems) return "Выбрать все"
      return "Выбрать все"
    },
  },

  watch: {
    selected(val) {
      if (this.single) {
        if (val.length > 1) this.value.shift()
      }
    },

    search(val) {
      if (this.debounceRequest == null) return
      this.debounceRequest(val)
    },
  },

  methods: {
    ...mapActions({
      loadAllProjects: 'graphql/loadAllProjects',
      loadProjects: 'graphql/loadProjects',
    }),

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = []
        } else {
          this.selected = this.selectorOptions.map((p) => p.id)
        }
      })
    },

    findProject(val) {
      this.loading = true
      let graphQuery = {
        query: `{
          projects(search: "${val || ''}") {
            id
            name
          }
        }`
      }
      this.loadProjects(graphQuery)
        .then(res => {this.selectorOptions = res})
        .finally(() => {this.loading = false})
    },

    async refresh() {
      this.selected = []
      this.search = ''
      this.loading = true
      await this.loadAllProjects()
      this.loading = false
    },

    getProjectName(projectId) {
      const project = this.allSelectorOptions.find(p => p.id === projectId)

      if (project) return project.name
      else return ''
    },
  },

  async mounted() {
    this.debounceRequest = this.utils.debounce(this.findProject, 700)
    await this.loadAllProjects()
    this.selectorOptions = this.allProjects
    this.allSelectorOptions = this.allProjects

    if (this.selectedAll || this.allSelectorOptions.length === 1) {
      this.selected = this.allSelectorOptions.map(p => p.id)
    }
    this.loading = false
  }
}
</script>

<style scoped lang="scss">
.sliced-name {
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>